/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanEngagementTrackingPortalRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const trackPlanVisitedRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanEngagementTrackingPortalRpc',
  rpcName: 'trackPlanVisited',
  auth: 'external',
  fingerprint: 'VccXK58Q10eOUe2e_r4XmQnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const trackLinkSharedRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanEngagementTrackingPortalRpc',
  rpcName: 'trackLinkShared',
  auth: 'external',
  fingerprint: 'ATxZGa-uedqOUe2e_r4XmQnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};